import axios from '../modules/marketplace/axios-marketplace';

const getCategorias = params => axios.get('/categorias/completos', { params });
const getCategoria = id => axios.get(`/categorias/completo/${id}`);

export default {
  getCategorias,
  getCategoria,
};
